import React from 'react';
import SelectComponent from "../../select/select-component.jsx";
import ReportUtils from "../../../utils/report-utils.js";
import InputForm from "../../input/input-form.jsx";

const HourTypeInput = ({ filters, setFilters, hasDateType = false }) => {

    return (
        <>
            <div className="flex gap-2">
                <InputForm
                    id="startHr"
                    label="Hora inicial *"
                    min="00"
                    max="23"
                    type="number"
                    value={filters.hrStart}
                    onChange={(e) => setFilters(prev => ({...prev, hrStart: ReportUtils.handleHourChange(e.target.value)}))}
                    onBlur={(e) => setFilters(prev => ({...prev, hrStart: ReportUtils.formatHourOnly(e.target.value)}))}
                    classNameWrapper={'w-[50%]'}
                />

                <InputForm
                    id="endHr"
                    label="Hora final *"
                    min="00"
                    max="23"
                    type="number"
                    value={filters.hrEnd}
                    onChange={(e) => setFilters(prev => ({...prev, hrEnd: ReportUtils.handleHourChange(e.target.value)}))}
                    onBlur={(e) => setFilters(prev => ({...prev, hrEnd: ReportUtils.formatHourOnly(e.target.value)}))}
                    classNameWrapper={'w-[50%]'}
                />
            </div>

            <SelectComponent
                label='Período *'
                isMulti={false}
                options={ReportUtils.periods()}
                value={filters.period}
                onChange={(value) => ReportUtils.periodChange(value, setFilters, true)}
                instanceId="period"
                classNameWrapper={"w-full"}
                isClearable={false}
            />

            { hasDateType && (
                <SelectComponent
                    label='Tipo de pesquisa *'
                    isMulti={false}
                    wrapValues={true}
                    options={[
                        {label: "Contínua", value: 'continuous'},
                        {label: "Período", value: 'period'}
                    ]}
                    value={filters.dtType}
                    onChange={(value) => setFilters(prev => ({...prev, dtType: value}))}
                    instanceId="dtType"
                    classNameWrapper={"w-full"}
                    isClearable={false}
                />
            )}
        </>
    );
};

export default HourTypeInput;